import React, { useState, useEffect, useCallback } from 'react';
import dayjs from 'dayjs';

import api from '../../../services/api';
import Rodape from '../../../components/Rodape';
import TicketList from './TicketList';
import CurrentTicket from './CurrentTicket';
import './AtendimentoMotorista.css';

const AtendimentoDeheus02 = () => {
  const [currentTicket, setCurrentTicket] = useState({
    number: '--',
    driver: 'Aguardando motorista',
    counter: '--'
  });
  const [previsaoEntrada, setPrevisaoEntrada] = useState([]);
  const [ultimosLiberados, setUltimosLiberados] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatEntryForecast = (dateString) => {
    if (!dateString) return 'Sem previsão de horário';

    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const processVisitData = (visita) => ({
    number: visita.number_cg || '--',
    driver: visita.visita_uuid?.name || 'Motorista não informado',
    //counter: visita.unit?.name || 'Unidade não especificada',
    eta: formatEntryForecast(visita.entry_forecast),
    timestamp: visita.arrival_date || new Date().toISOString()
  });

  const fetchTickets = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      //const response = await api.get('/api/front/atendimento/completo/deheus01', {
      const response = await api.get('/oapi/front/atentimento/deheus02', {
        headers: { Authorization: `Bearer ${token}` }
      });


      const aguardandoData = response.data.aguardando_liberacao.map(processVisitData);
      setPrevisaoEntrada(aguardandoData);
      const liberadosData = response.data.ultimos_liberados.map(processVisitData);
      setUltimosLiberados(liberadosData);

      setError(null);
    } catch (err) {
      console.error('Erro ao buscar tickets:', err);
      setError('Erro ao carregar dados. Tentando novamente...');
    } finally {
      setIsLoading(false);
    }
  }, []);


  useEffect(() => {
    fetchTickets();
    const interval = setInterval(fetchTickets, 30000);
    return () => clearInterval(interval);
  }, [fetchTickets]);

  useEffect(() => {
    if (!ultimosLiberados || ultimosLiberados.length < 2) {
      if (ultimosLiberados.length === 1) {
        setCurrentTicket(ultimosLiberados[0]);
      }
      return;
    }

    let index = 0;
    setCurrentTicket(ultimosLiberados[index]);

    const interval = setInterval(() => {
      index = (index + 1) % ultimosLiberados.length;
      setCurrentTicket(ultimosLiberados[index]);
    }, 15000);

    return () => clearInterval(interval);
  }, [ultimosLiberados]);


  return (
    <div className="atendimento-container">
      <div className="atendimento">
        <header className="atendimento-header">
          <h1>De Heus 02 (Av. Brasil, 1590)</h1>
          {isLoading && <div className="loading-indicator">Atualizando...</div>}
          {error && <div className="error-message">{error}</div>}
        </header>

        <div className="atendimento-body">
          <div className="left-section">
            <TicketList title="Previsão de Entrada" tickets={previsaoEntrada} type="previsao-entrada" />
          </div>
          <div className="right-section">
            <CurrentTicket {...currentTicket} />
            <TicketList title="Entradas Liberadas na Unidade" tickets={ultimosLiberados} type="ultimos-liberados" />
          </div>
        </div>
      </div>
      <Rodape />
    </div>
  );
};

export default AtendimentoDeheus02;